<template>
  <div class="figures">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="figures__figure"
      :data-field="dataFieldFor(index)"
    >
      <span class="figures__figure-label">{{ item.label }}</span>
      <span
        class="figures__figure-value"
        :class="item.variant ? `figures__figure-value--${item.variant}` : ''"
      >
        {{ item.value }}
      </span>
    </div>
  </div>
</template>

<script>
import DataFieldByIndex from './DataFieldByIndex'

export default {
  name: 'BaseFigures',
  mixins: [DataFieldByIndex],
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
.figures {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;

  &__figure {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__figure-label {
    font-size: 0.8rem;
    color: var(--ds-color-black-055);
  }

  &__figure-value {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.01em;
    color: var(--v-textPrimary-base);

    &--warning {
      color: var(--v-warning-base);
    }

    &--error {
      color: var(--v-error-base);
    }
  }
}
</style>
